export class TimeoutError extends Error {
  public isTimeout = true;
  public status = 504;

  public constructor(message: string) {
    super(message);
    this.name = 'TimeoutError';

    Error.captureStackTrace(this, TimeoutError);
  }
}
